import { useEffect } from "react";

import { useRequestActivity } from "@/core/request-activity";

const LOADING_LABEL = "Carregando";
const TIPOS_BLOQUEADOS = ["keydown", "keyup", "keypress"] as const;

function bloquearTeclado(event: Event): void {
  event.preventDefault();
  event.stopPropagation();
}

export function useRequestLoading() {
  const { visible, blocking, indicator } = useRequestActivity();

  useEffect(() => {
    if (!blocking) return;

    TIPOS_BLOQUEADOS.forEach((tipo) => document.addEventListener(tipo, bloquearTeclado, true));
    return () => {
      TIPOS_BLOQUEADOS.forEach((tipo) => document.removeEventListener(tipo, bloquearTeclado, true));
    };
  }, [blocking]);

  return {
    visivel: visible && typeof document !== "undefined",
    bloqueando: blocking,
    comIndicador: indicator,
    rotulo: LOADING_LABEL,
  };
}
